<template>
  <div>
    <q-linear-progress v-if="isFetching" indeterminate />
    <q-form v-else @submit="onSubmit" class="form">
      <div class="form__item">
        <CustomSelect
          :options="projectsOptions"
          label="Проект для дублирования исполнителей"
          optionValueKey="project_id"
          optionLabelKey="labelWithId"
          :value="formData.project_id || ''"
          @change="(value) => onChange('project_id', value)"
          :required="true"
          :clearable="false"
        />
      </div>

      <CustomModalFooter :btn-loading="loading" />
    </q-form>
  </div>
</template>

<script>
import CustomSelect from "@/components/form/CustomSelect";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import { getResidentDetailedInfo } from "@/views/ProjectsEntry/services";

export default {
  name: "duplicate-project-performers",
  components: { CustomSelect, CustomModalFooter },
  props: ["data"],
  data() {
    return {
      loading: false,
      isFetching: false,
      projectsOptions: [],
      formData: {
        project_id: "",
      },
    };
  },
  async mounted() {
    this.isFetching = true;
    await this.loadProjectsOptions();
    this.isFetching = false;
  },
  methods: {
    async loadProjectsOptions() {
      const resident_id = this.data?.resident_id;
      const project_type_id = this.data?.project_type_id;
      const current_project_id = this.data?.current_project_id;

      if (!resident_id || !project_type_id) {
        this.projectsOptions = [];
        return;
      }

      const res = await getResidentDetailedInfo({ resident_id, project_type_id });
      const list = Array.isArray(res) ? res : [];

      this.projectsOptions = list
        .filter((p) => p.project_id && p.project_id !== current_project_id)
        .map((item) => ({
          ...item,
          labelWithId: `${item.resident_name} (ID - ${item.project_id})`,
        }));
    },
    onChange(key, value) {
      this.formData[key] = value;
    },
    async onSubmit() {
      this.loading = true;
      try {
        await this.data?.onSubmit(this.formData);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.form {
  display: flex;
  flex-direction: column;
  min-width: 350px;
  gap: 16px;

  @media (max-width: 428px) {
    min-width: 100%;
  }
}
</style>

